import { useLanguage } from "@/context/LanguageContext";
import { HOME } from "@/constants/testIds";

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const isFR = language === "fr";
  return (
    <div
      className="inline-flex items-center gap-1 text-[0.7rem] tracking-[0.28em] uppercase font-sans"
      role="group"
      aria-label="Language toggle"
    >
      <button
        data-testid={HOME.langToggle + "-fr"}
        onClick={() => setLanguage("fr")}
        className={`px-2 py-1 transition-colors duration-300 ${
          isFR ? "text-gold" : "text-ivory/50 hover:text-ivory"
        }`}
      >
        FR
      </button>
      <span className="text-gold/40">·</span>
      <button
        data-testid={HOME.langToggle + "-en"}
        onClick={() => setLanguage("en")}
        className={`px-2 py-1 transition-colors duration-300 ${
          !isFR ? "text-gold" : "text-ivory/50 hover:text-ivory"
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
